// removed by extract-text-webpack-plugin
module.exports = {"root":"_1VM9x","header":"_3OF5g","title":"_1Z2dr","image":"_l1P7D"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Post/components/PostContent/components/ArticlePostContent/ArticlePostContent.scss
// module id = 1189
// module chunks = 2